import { DECREASEQTY, INCREASEQTY, PRODUCTADD, PRODUCTDELETED } from "./ActionType";
import initialProduct from "./initialProduct";

const productReducer = (state = initialProduct, action) => {

  const idGenerator = (products) => {
    const maxId = products.reduce((maxId, product) => Math.max(product.id, maxId), -1);
    return maxId + 1;
};

  switch (action.type) {
    
    case PRODUCTADD:
      return [...state, {
        ...action.payload,
        id: idGenerator(state),
        currentQty: action.payload.initialQty
      }];

    case INCREASEQTY:
      return state.map((product) => {
        if (product.id === action.payload) {
          return {
            ...product,
            currentQty: product.currentQty + 1,
          };
        } else {
          return product;
        }
      });

    case DECREASEQTY:
      return state.map((product) => {
        if (product.id === action.payload) {
          return {
            ...product,
            currentQty: product.currentQty - 1,
          };
        } else {
          return product;
        }
      });

    case PRODUCTDELETED:
      return state.map((product) => {
        if (product.id === action.payload) {
          return {
            ...product,
            currentQty: product.initialQty,
          };
        } else {
          return product;
        }
      });

    default:
      return state;
  }
};

export default productReducer;
